import { library, dom } from '@fortawesome/fontawesome-svg-core'

import {
	faLink as fasLink,
} from '@fortawesome/free-solid-svg-icons'

import {
	faEnvelope as farEnvelope,
} from '@fortawesome/free-regular-svg-icons'

import {
	faFacebookF as fabFacebook,
	faInstagram as fabInstagram,
	faTwitter as fabTwitter,
	faXTwitter as fabXTwitter,
	faPinterest as fabPinterest,
	faLinkedin as fabLinkedIn,
	faLinkedinIn as fabLinkedInIn,
	faGetPocket as fabGetPocket,
} from '@fortawesome/free-brands-svg-icons';

library.add(
	// Solid
	fasLink,

	// Regular
	farEnvelope,

	// Brands
	fabFacebook,
	fabInstagram,
	fabLinkedIn,
	fabLinkedInIn,
	fabPinterest,
	fabTwitter,
	fabXTwitter,
	fabGetPocket,
)

dom.watch()
